import styled from "styled-components";

export default styled.div`
  padding: 3rem;
  @media (max-width: 768px) {
    padding: 1rem;
  }
  align-self: center;
`;
